(function () {
  // --- Init global ADDON_IDS from the JSON script ---
  (function initAddonIds() {
    var el =
      document.getElementById('addon-ids-' + (window.BLOCK_ID || '')) ||
      document.querySelector('script[id^="addon-ids-"]');

    window.ADDON_IDS = {};
    if (!el) {
      console.warn('addon-ids JSON not found');
      return;
    }
    try {
      var list = JSON.parse(el.textContent || '[]');
      list.forEach(function (item) {
        window.ADDON_IDS[item.k] = Number(item.id || 0);
      });
    } catch (e) {
      console.error('Invalid add-on JSON', e);
    }
  })();

  // Helper function to resolve image URLs
  function resolveImageUrl(filename) {
    if (!filename) return '';
    
    // If already a full URL (from Shopify asset_url filter), return as-is
    if (filename.startsWith('http://') || filename.startsWith('https://') || filename.startsWith('//')) {
      return filename;
    }
    
    // Legacy fallback for relative paths (should not be needed with asset_url filter)
    var baseUrl = (window.Shopify && window.Shopify.CDN && window.Shopify.CDN.shop_url) || 
                  document.querySelector('link[rel="stylesheet"]')?.href?.split('/cdn/')[0] || 
                  '';
    
    if (baseUrl) {
      return baseUrl + '/cdn/shop/files/' + filename;
    }
    
    // Final fallback: try to construct from current domain
    var protocol = window.location.protocol;
    var domain = window.location.hostname;
    return protocol + '//cdn.shopify.com/s/files/1/0000/0000/files/' + filename;
  }

  // Placeholder images for fallback
  var placeholderImages = {
    bronze: 'https://via.placeholder.com/400x300/CD7F32/FFFFFF?text=Bronze+PC',
    silver: 'https://via.placeholder.com/400x300/C0C0C0/000000?text=Silver+PC',
    gold: 'https://via.placeholder.com/400x300/FFD700/000000?text=Gold+PC',
    platinum: 'https://via.placeholder.com/400x300/E5E4E2/000000?text=Platinum+PC',
    emerald: 'https://via.placeholder.com/400x300/50C878/FFFFFF?text=Emerald+PC'
  };

  function getImageUrl(filename, tierId) {
    if (!filename || filename.trim() === '') {
      return placeholderImages[tierId] || '';
    }
    
    var resolvedUrl = resolveImageUrl(filename);
    
    // Add fallback image as onerror handler will be set on img elements
    return resolvedUrl;
  }

  function toNumber(v) {
    var n = Number(v);
    return isNaN(n) ? 0 : n;
  }

  function initBuilder(root) {
    var builderId = root.getAttribute('data-builder-id') || '';

    // --- Read config JSON ---
    var cfgScript = root.querySelector('.pc-builder-config');
    if (!cfgScript) {
      console.error('pc-builder-config not found');
      return;
    }

    var tiers = [];
    try {
      var cfg = JSON.parse(cfgScript.textContent || '{}');
      tiers = cfg.tiers || [];
    } catch (e) {
      console.error('Invalid pc-builder-config JSON', e);
      return;
    }
    if (!tiers.length) return;

    var basePrices = {};
    var tierSpecs = {};
    var tierNames = {};
    tiers.forEach(function (t) {
      basePrices[t.id] = toNumber(t.price);
      tierSpecs[t.id] = {
        ram: toNumber(t.ram),
        ddr: toNumber(t.ddr),
        storage: toNumber(t.storage_gb)
      };
      tierNames[t.id] = t.name || t.id;
    });

    var selectedTier = tiers[0].id;
    var selectedUpgrades = [];

    var budgetCardsEl = root.querySelector('[data-role="budget-cards"]');
    var builderCardsEl = root.querySelector('[data-role="builder-cards"]');
    var selectedNameEl = root.querySelector('[data-role="selected-tier-name"]');
    var selectedPriceEl = root.querySelector('[data-role="selected-tier-price"]');
    var selectedImageEl = root.querySelector('[data-role="selected-pc-image"]');
    var totalPriceEl = root.querySelector('[data-role="total-price"]');
    var customizationSection = root.querySelector('[data-role="customization-section"]');
    var pendingScrollTimeout = null;

    if (customizationSection && !customizationSection.id) {
      customizationSection.id = 'pc-customization-' + (builderId || Math.random().toString(36).slice(2));
    }

    function resolveCustomizationSection() {
      var target =
        customizationSection ||
        root.querySelector('[data-role="customization-section"]') ||
        document.querySelector('[data-role="customization-section"]');

      if (target) {
        customizationSection = target;
      }
      return target;
    }

    function scrollToCustomizationSection() {
      var targetSection = resolveCustomizationSection();
      if (!targetSection) return;

      var offsetAttr = root.getAttribute('data-scroll-offset');
      var offset = offsetAttr ? toNumber(offsetAttr) : 0;

      var targetRect = targetSection.getBoundingClientRect();
      var targetTop = targetRect.top + window.pageYOffset - offset;

      targetSection.scrollIntoView({ behavior: 'smooth', block: 'start' });

      window.requestAnimationFrame(function () {
        window.scrollTo({
          top: targetTop < 0 ? 0 : targetTop,
          behavior: 'smooth'
        });
      });
    }

    function queueScrollToCustomizationSection(delay) {
      if (pendingScrollTimeout) {
        clearTimeout(pendingScrollTimeout);
      }

      pendingScrollTimeout = window.setTimeout(function () {
        pendingScrollTimeout = null;
        scrollToCustomizationSection();
      }, delay || 300);
    }
    var addToCartBtn = root.querySelector('[data-role="add-to-cart"]');

    var fpsFortniteEl = root.querySelector('[data-role="fps-fortnite"]');
    var fpsBlackopsEl = root.querySelector('[data-role="fps-blackops"]');
    var fpsF1El = root.querySelector('[data-role="fps-f1"]');

    var memoryDropdown = root.querySelector('[data-role="memory-dropdown"]');
    var storageDropdown = root.querySelector('[data-role="storage-dropdown"]');
    var connectivityDropdown = root.querySelector('[data-role="connectivity-dropdown"]');

    // --- Build cards ---
    function createCard(tier) {
      var card = document.createElement('div');
      card.className = 'tier-card ' + tier.id;
      card.dataset.tier = tier.id;
      card.setAttribute('tabindex', '0');
      card.setAttribute('role', 'button');
      card.setAttribute('aria-expanded', 'false');
      card.setAttribute('aria-label', tier.name + ' tier card');

      // === COLLAPSED STATE ===
      var collapsedDiv = document.createElement('div');
      collapsedDiv.className = 'card-collapsed';

      // Badge
      if (tier.badge) {
        var badge = document.createElement('div');
        badge.className = 'tier-badge';
        badge.textContent = tier.badge;
        card.appendChild(badge);
      }

      // Header
      var headerDiv = document.createElement('div');
      headerDiv.className = 'card-header';
      
      var nameEl = document.createElement('h3');
      nameEl.className = 'tier-name ' + tier.id;
      nameEl.textContent = tier.name;
      headerDiv.appendChild(nameEl);

      if (tier.short_use) {
        var shortUseEl = document.createElement('p');
        shortUseEl.className = 'tier-short-use';
        shortUseEl.textContent = tier.short_use;
        headerDiv.appendChild(shortUseEl);
      }
      collapsedDiv.appendChild(headerDiv);

      // Image
      if (tier.image) {
        var imgContainer = document.createElement('div');
        imgContainer.className = 'card-image-container';
        var img = document.createElement('img');
        img.src = getImageUrl(tier.image, tier.id);
        img.alt = tier.name;
        img.className = 'card-image';
        img.onerror = function() {
          this.src = placeholderImages[tier.id] || '';
        };
        imgContainer.appendChild(img);
        collapsedDiv.appendChild(imgContainer);
      }

      // Spec chips
      var chipsDiv = document.createElement('div');
      chipsDiv.className = 'spec-chips';
      
      var cpuChip = document.createElement('span');
      cpuChip.className = 'spec-chip cpu';
      cpuChip.textContent = tier.cpu;
      chipsDiv.appendChild(cpuChip);

      var gpuChip = document.createElement('span');
      gpuChip.className = 'spec-chip gpu';
      gpuChip.textContent = tier.gpu;
      chipsDiv.appendChild(gpuChip);

      var ramChip = document.createElement('span');
      ramChip.className = 'spec-chip ram';
      ramChip.textContent = tier.ram + 'GB DDR' + tier.ddr;
      chipsDiv.appendChild(ramChip);

      var storageChip = document.createElement('span');
      storageChip.className = 'spec-chip storage';
      storageChip.textContent = tier.storage_label;
      chipsDiv.appendChild(storageChip);

      collapsedDiv.appendChild(chipsDiv);

      // Price
      var priceEl = document.createElement('div');
      priceEl.className = 'tier-price';
      priceEl.textContent = '$' + tier.price;
      collapsedDiv.appendChild(priceEl);

      // View Details Button
      var viewBtn = document.createElement('button');
      viewBtn.className = 'view-details-btn';
      viewBtn.textContent = 'View Details';
      viewBtn.setAttribute('data-action', 'toggle');
      collapsedDiv.appendChild(viewBtn);

      card.appendChild(collapsedDiv);

      // === EXPANDED STATE ===
      var expandedDiv = document.createElement('div');
      expandedDiv.className = 'card-expanded';

      var expandedContent = document.createElement('div');
      expandedContent.className = 'expanded-content';

      function createBuyButton() {
        var btn = document.createElement('button');
        btn.className = 'customize-buy-btn';
        btn.type = 'button';
        btn.textContent = 'Buy Now';
        btn.setAttribute('data-action', 'customize');
        btn.setAttribute('data-tier-id', tier.id); // Store tier ID for debugging
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          
          // Call selectTier first
          selectTier(tier.id);
          
          var delay = card && card.classList.contains('expanded') ? 150 : 350;
          queueScrollToCustomizationSection(delay);
        }); // Removed capture phase to ensure consistent behavior
        return btn;
      }

      // Tagline
      var taglineEl = document.createElement('p');
      taglineEl.className = 'tagline-text';
      taglineEl.textContent = tier.tagline;
  expandedContent.appendChild(taglineEl);

  var topBuyButton = createBuyButton();
  expandedContent.appendChild(topBuyButton);

      // Full specs
      var specsTitle = document.createElement('h4');
      specsTitle.className = 'full-specs-title';
      specsTitle.textContent = 'Full Specifications';
      expandedContent.appendChild(specsTitle);

      var specsList = document.createElement('ul');
      specsList.className = 'full-specs-list';

      var specs = [
        { label: 'CPU', value: tier.cpu },
        { label: 'GPU', value: tier.gpu },
        { label: 'RAM', value: tier.ram + 'GB DDR' + tier.ddr },
        { label: 'Storage', value: tier.storage_label }
      ];

      if (tier.full_specs) {
        if (tier.full_specs.motherboard) specs.push({ label: 'Motherboard', value: tier.full_specs.motherboard });
        if (tier.full_specs.psu) specs.push({ label: 'PSU', value: tier.full_specs.psu });
        if (tier.full_specs.case) specs.push({ label: 'Case', value: tier.full_specs.case });
        if (tier.full_specs.cooling) specs.push({ label: 'Cooling', value: tier.full_specs.cooling });
      }

      specs.forEach(function(spec) {
        var li = document.createElement('li');
        var label = document.createElement('span');
        label.className = 'spec-label';
        label.textContent = spec.label + ':';
        li.appendChild(label);
        li.appendChild(document.createTextNode(' ' + spec.value));
        specsList.appendChild(li);
      });

      expandedContent.appendChild(specsList);

      // Badges
      if (tier.badges && tier.badges.length) {
        var badgeList = document.createElement('div');
        badgeList.className = 'badge-list';
        tier.badges.forEach(function(badgeText) {
          var badgeSpan = document.createElement('span');
          badgeSpan.className = 'tier-feature-badge';
          badgeSpan.textContent = badgeText;
          badgeList.appendChild(badgeSpan);
        });
        expandedContent.appendChild(badgeList);
      }

      // Actions
      var actionsDiv = document.createElement('div');
      actionsDiv.className = 'expanded-actions';

      var bottomBuyButton = createBuyButton();
      actionsDiv.appendChild(bottomBuyButton);

      expandedContent.appendChild(actionsDiv);
      expandedDiv.appendChild(expandedContent);
      card.appendChild(expandedDiv);

      // === EVENT LISTENERS ===
      
      // Toggle expand/collapse
      viewBtn.addEventListener('click', function(e) {
        e.stopPropagation();
        toggleCardExpansion(card, tier.id);
      });

      // Card click toggles (but not on buttons/links)
      card.addEventListener('click', function(e) {
        if (!e.target.closest('button') && !e.target.closest('a')) {
          toggleCardExpansion(card, tier.id);
        }
      });

      card.addEventListener('keydown', function (e) {
        var key = e.key;
        if (key === 'Enter' || key === ' ') {
          e.preventDefault();
          toggleCardExpansion(card, tier.id);
        }
      });

      return card;
    }

    // Toggle card expansion (one at a time per category)
    function toggleCardExpansion(clickedCard, tierId) {
      var isExpanded = clickedCard.classList.contains('expanded');
      
      // Find the category this card belongs to
      var section = clickedCard.closest('.tier-section');
      if (section) {
        var cardsInSection = section.querySelectorAll('.tier-card');
        cardsInSection.forEach(function(card) {
          card.classList.remove('expanded');
          card.setAttribute('aria-expanded', 'false');
        });
      }

      // Toggle this card
      if (!isExpanded) {
        clickedCard.classList.add('expanded');
        clickedCard.setAttribute('aria-expanded', 'true');
        selectTier(tierId);
      }
    }

    if (budgetCardsEl) budgetCardsEl.innerHTML = '';
    if (builderCardsEl) builderCardsEl.innerHTML = '';

    tiers.forEach(function (tier) {
      var card = createCard(tier);
      if (tier.category === 'budget' && budgetCardsEl) {
        budgetCardsEl.appendChild(card);
      } else if (tier.category === 'builder' && builderCardsEl) {
        builderCardsEl.appendChild(card);
      }
    });

    // --- Upgrades (now dropdowns) ---
    if (memoryDropdown) {
      memoryDropdown.addEventListener('change', function (e) {
        handleDropdownChange('memory', e.target);
      });
    }
    if (storageDropdown) {
      storageDropdown.addEventListener('change', function (e) {
        handleDropdownChange('storage', e.target);
      });
    }
    if (connectivityDropdown) {
      connectivityDropdown.addEventListener('change', function (e) {
        handleDropdownChange('connectivity', e.target);
      });
    }

    function handleDropdownChange(type, dropdown) {
      var selectedOption = dropdown.options[dropdown.selectedIndex];
      var value = selectedOption.value;
      var price = toNumber(selectedOption.getAttribute('data-price') || 0);

      // Remove existing upgrade of this type
      selectedUpgrades = selectedUpgrades.filter(function (u) {
        return u.type !== type;
      });

      // Add new upgrade if not base config
      if (value) {
        selectedUpgrades.push({ type: type, value: value, price: price });
      }

      updateTotal();
      updateFPS();
    }

    function clearUpgrades() {
      selectedUpgrades = [];
      if (memoryDropdown) memoryDropdown.selectedIndex = 0;
      if (storageDropdown) storageDropdown.selectedIndex = 0;
      if (connectivityDropdown) connectivityDropdown.selectedIndex = 0;
    }

    function updateMemoryOptions() {
      if (!memoryDropdown) return;
      var specs = tierSpecs[selectedTier];
      if (!specs) return;

      // Hide incompatible memory options
      Array.from(memoryDropdown.options).forEach(function (opt, idx) {
        if (idx === 0) return; // skip base config
        var ddr = toNumber(opt.getAttribute('data-ddr'));
        var total = toNumber(opt.getAttribute('data-total'));
        if (ddr && total && (ddr !== specs.ddr || total <= specs.ram)) {
          opt.disabled = true;
          opt.style.display = 'none';
        } else {
          opt.disabled = false;
          opt.style.display = '';
        }
      });
      memoryDropdown.selectedIndex = 0;
    }

    function updateSelectedDisplay() {
      if (selectedNameEl) {
        var displayName = tierNames[selectedTier] || (selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1));
        selectedNameEl.textContent = displayName;
      }
      if (selectedPriceEl) selectedPriceEl.textContent = basePrices[selectedTier] || 0;
      
      // Update PC image
      if (selectedImageEl) {
        var tier = tiers.find(function (t) { return t.id === selectedTier; });
        if (tier && tier.image) {
          selectedImageEl.src = getImageUrl(tier.image, tier.id);
          selectedImageEl.alt = tier.name + ' PC';
          selectedImageEl.onerror = function() {
            this.src = placeholderImages[selectedTier] || '';
          };
        }
      }
    }

    function updateFPS() {
      // Placeholder FPS data - you can replace this with real data
      var tier = tiers.find(function (t) { return t.id === selectedTier; });
      if (!tier) return;

      var fpsData = {
        bronze: { fortnite: '60-80 FPS', blackops: '50-70 FPS', f1: '55-75 FPS' },
        silver: { fortnite: '90-120 FPS', blackops: '80-100 FPS', f1: '85-110 FPS' },
        gold: { fortnite: '120-144 FPS', blackops: '110-130 FPS', f1: '115-140 FPS' },
        platinum: { fortnite: '144-165 FPS', blackops: '130-160 FPS', f1: '140-165 FPS' },
        emerald: { fortnite: '165-240 FPS', blackops: '160-200 FPS', f1: '165-200 FPS' }
      };

      var data = fpsData[selectedTier] || { fortnite: '—', blackops: '—', f1: '—' };

      if (fpsFortniteEl) fpsFortniteEl.textContent = data.fortnite;
      if (fpsBlackopsEl) fpsBlackopsEl.textContent = data.blackops;
      if (fpsF1El) fpsF1El.textContent = data.f1;
    }

    function updateTotal() {
      var base = basePrices[selectedTier] || 0;
      var upgrades = selectedUpgrades.reduce(function (sum, u) {
        return sum + toNumber(u.price);
      }, 0);
      var total = base + upgrades;
      if (totalPriceEl) totalPriceEl.textContent = total;
    }

    function selectTier(tierId) {
      if (!basePrices[tierId]) return;
      selectedTier = tierId;

      // nav active
      root.querySelectorAll('.tier-nav-button').forEach(function (btn) {
        btn.classList.toggle('active', btn.dataset.tier === tierId);
      });

      // card active
      root.querySelectorAll('.tier-card').forEach(function (card) {
        var isSelected = card.dataset.tier === tierId;
        card.classList.toggle('active', isSelected);
        card.setAttribute('data-selected', isSelected ? 'true' : 'false');
      });

      clearUpgrades();
      updateMemoryOptions();
      updateSelectedDisplay();
      updateTotal();
    }

    // --- Add to cart ---
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function () {
        addToCart();
      });
    }

    function getVariantIdForTier(tierId) {
      var map = {
        bronze: root.getAttribute('data-bronze-variant-id'),
        silver: root.getAttribute('data-silver-variant-id'),
        gold: root.getAttribute('data-gold-variant-id'),
        platinum: root.getAttribute('data-platinum-variant-id'),
        emerald: root.getAttribute('data-emerald-variant-id')
      };
      var fallback = root.getAttribute('data-default-variant-id');
      var raw = map[tierId] || fallback || '';
      return toNumber(raw);
    }

    function addToCart() {
      var baseId = getVariantIdForTier(selectedTier);
      if (!baseId) {
        alert('Please configure product variant IDs in the block settings.');
        return;
      }

      var totalDisplayed = totalPriceEl ? totalPriceEl.textContent : '';

      var items = [{
        id: baseId,
        quantity: 1,
        properties: {
          _group: 'PC Builder',
          'PC Tier': selectedTier.charAt(0).toUpperCase() + selectedTier.slice(1),
          'Base Price': '$' + (basePrices[selectedTier] || 0),
          'Displayed Total': '$' + totalDisplayed
        }
      }];

      selectedUpgrades.forEach(function (u) {
        var addonId = (window.ADDON_IDS || {})[u.value];
        if (!addonId) return;
        items.push({
          id: addonId,
          quantity: 1,
          properties: {
            _group: 'PC Builder',
            _parent: String(baseId),
            'Upgrade': u.value.replace(/_/g, ' ').toUpperCase()
          }
        });
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json'
        },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) {
          return r.text().then(function (t) {
            if (!r.ok) {
              try {
                var err = JSON.parse(t);
                alert(err.description || t);
              } catch (e) {
                alert(t);
              }
              return;
            }
            window.location.href = '/cart';
          });
        })
        .catch(function (err) {
          console.error(err);
          alert('Could not add to cart. Please try again.');
        });
    }

    // --- Initial state ---
    updateMemoryOptions();
    updateSelectedDisplay();
    updateTotal();
    updateFPS();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('pc-builder-[data-builder-id], pc-builder-[data-builder-id=""]').forEach(function (el) {
      // selector above is a bit ugly; safer to fall back:
    });

    // simpler: just find any element with data-builder-id
    document.querySelectorAll('[data-builder-id]').forEach(function (el) {
      initBuilder(el);
    });
  });
})();